module.exports = __webpack_public_path__ + "static/img/document_logo.7be2b3d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/document_logo.jpg
// module id = LPlM
// module chunks = 2